module.exports = __webpack_public_path__ + "img/googleDriveIconLarge.b2169462.png";